import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puzte = () => {
    return (
        <div>
             <NavLink to='/category/Puzzels/Puzzel11'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel9'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">A Man with Medical Condition and 2 Pills</h1>
   
    <div class="text">
        <p><strong><u>Puzzle</u>: </strong>A man has a medical condition that requires him to take two kinds of pills,
            call them A and B. The man must take exactly one A pill and exactly one B pill each day, or he will die. The
            pills are taken by first dissolving them in water.&nbsp;</p>
        <p>The man has a jar of A pills and a jar of B pills. One day, as he is about to take his pills, he takes out
            one A pill from the A jar and puts it in a glass of water. Then he accidentally takes out two B pills from
            the B jar and puts them in the water. Now, he is in the situation of having a glass of water with three
            dissolved pills, one A pill and two B pills. Unfortunately, the pills are very expensive, so the thought of
            throwing out the water with the 3 pills and starting over is out of the question. How should the man proceed
            in order to get the right quantity of A and B while not wasting any pills?&nbsp;<br/>&nbsp;</p>
       
        <p><strong><u>Solution</u>:</strong> Follow this step-wise approach to help the man take his medicine in a
            correct way.&nbsp;&nbsp;</p>
        <ol>
            <li><strong>Step 1:</strong> Add one more A pill to the glass and let it dissolve.</li>
            <li><strong>Step 2:</strong> Take half of the water today and half tomorrow.</li>
        </ol>
        <p>It works under the following assumptions.&nbsp;&nbsp;</p><br/>
        
        <ul>
            <li>The dissolved Pills can be used the next day.</li>
            <li>The man has to take pills at least for one more day.</li>
        </ul>
        <p><strong><u>Alternate Solution:</u></strong></p>
        <ol>
            <li>The person can boil the solution in jar B and water gets evaporated. Thus, the residue of medicine will
                be left.</li>
            <li>Now he can take half of<strong> </strong>the residue, which will be equivalent to a single pill and take
                the rest tomorrow.</li>
        </ol>
        <p>It works under the following assumptions:</p>
        <ul>
            <li>Some of the medicine does not evaporate with water.</li>
        </ul>
        <p>&nbsp;&nbsp;</p>
        
    </div>
</article>
        </div>
    )
}

export default Puzte
